var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSaveWhiteIcon = function SvgSaveWhiteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C5158",
    d: "M14.375 2.5h-8.75a1.25 1.25 0 0 0-1.25 1.25V17.5a.625.625 0 0 0 .956.53L10 15.112l4.67 2.918a.625.625 0 0 0 .955-.53V3.75a1.25 1.25 0 0 0-1.25-1.25m0 13.873-4.044-2.528a.63.63 0 0 0-.663 0l-4.043 2.528V3.75h8.75z"
  })));
};
export default SvgSaveWhiteIcon;